import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import svTranslation from './locales/sv';

i18n
  // pass the i18n instance to react-i18next
  .use(initReactI18next)
  // init i18next
  .init({
    resources: {
      sv: {
        translation: svTranslation
      }
    },
    lng: 'sv', // force language to Swedish
    fallbackLng: 'sv',
    
    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    }
  });

export default i18n; 